import { MapPinIcon } from '@heroicons/react/24/solid';
import { APIProvider, Map as GoogleMapComponent, type MapProps } from '@vis.gl/react-google-maps';
import { v4 as uuidv4 } from 'uuid';

interface IGoogleMapProps extends MapProps {
  children?: any;
  defaultZoom?: number;
}

const GoogleMap = ({ children, defaultZoom = 6, defaultCenter, mapId = uuidv4(), ...props }: IGoogleMapProps) => {
  return (
    <>
      <APIProvider apiKey='AIzaSyDh9oN6DizaCX6hnEaKagp62L7L1Fne6ss'>
        <GoogleMapComponent defaultCenter={defaultCenter} defaultZoom={defaultZoom} mapId={mapId} {...props}>
          {children ? children : <MapPinIcon className='h-8 w-8 text-red-500' />}
        </GoogleMapComponent>
      </APIProvider>

      {/* <GoogleMapReact
        bootstrapURLKeys={{
          key: 'AIzaSyA48aQrn851rBQKZfB3FK5E4iSw0LUDRXs',
          language: 'en',
        }}
        defaultZoom={defaultZoom}
        {...props}
      >
        {children ? (
          children
        ) : (
          <MapPinIcon className='h-8 w-8 text-red-500' />
        )}
      </GoogleMapReact> */}
    </>
  );
};

export default GoogleMap;
